/** FF003 雇入れ時健康診断調査票 — section titles */
export const HIRE_HEALTH_SECTION_GENERAL = '一般';
export const HIRE_HEALTH_SECTION_PNEUMO = 'じん肺';
export const HIRE_HEALTH_SECTION_VIBRATION = '振動';
export const HIRE_HEALTH_SECTION_HEARING = '難聴';
export const HIRE_HEALTH_SECTION_SPECIALIZED = '特化物（溶接ヒューム）';
export const HIRE_HEALTH_SECTION_AFTEREFFECTS = '既往症・後遺症など';
export const HIRE_HEALTH_AFTEREFFECTS_HINT =
  'ある傷害、持病、既往歴や後遺症などがある場合は。';
